import hearts_2 from '../assets/images/cards/2_of_hearts.gif';
import hearts_3 from '../assets/images/cards/3_of_hearts.gif';
import hearts_4 from '../assets/images/cards/4_of_hearts.gif';
import hearts_5 from '../assets/images/cards/5_of_hearts.gif';
import hearts_6 from '../assets/images/cards/6_of_hearts.gif';
import hearts_7 from '../assets/images/cards/7_of_hearts.gif';
import hearts_8 from '../assets/images/cards/8_of_hearts.gif';
import hearts_9 from '../assets/images/cards/9_of_hearts.gif';
import hearts_10 from '../assets/images/cards/10_of_hearts.gif';
import hearts_jack from '../assets/images/cards/jack_of_hearts.gif';
import hearts_queen from '../assets/images/cards/queen_of_hearts.gif';
import hearts_king from '../assets/images/cards/king_of_hearts.gif';
import hearts_ace from '../assets/images/cards/ace_of_hearts.gif';
import clubs_2 from '../assets/images/cards/2_of_clubs.gif';
import clubs_3 from '../assets/images/cards/3_of_clubs.gif';
import clubs_4 from '../assets/images/cards/4_of_clubs.gif';
import clubs_5 from '../assets/images/cards/5_of_clubs.gif';
import clubs_6 from '../assets/images/cards/6_of_clubs.gif';
import clubs_7 from '../assets/images/cards/7_of_clubs.gif';
import clubs_8 from '../assets/images/cards/8_of_clubs.gif';
import clubs_9 from '../assets/images/cards/9_of_clubs.gif';
import clubs_10 from '../assets/images/cards/10_of_clubs.gif';
import clubs_jack from '../assets/images/cards/jack_of_clubs.gif';
import clubs_queen from '../assets/images/cards/queen_of_clubs.gif';
import clubs_king from '../assets/images/cards/king_of_clubs.gif';
import clubs_ace from '../assets/images/cards/ace_of_clubs.gif';
import spades_2 from '../assets/images/cards/2_of_spades.gif';
import spades_3 from '../assets/images/cards/3_of_spades.gif';
import spades_4 from '../assets/images/cards/4_of_spades.gif';
import spades_5 from '../assets/images/cards/5_of_spades.gif';
import spades_6 from '../assets/images/cards/6_of_spades.gif';
import spades_7 from '../assets/images/cards/7_of_spades.gif';
import spades_8 from '../assets/images/cards/8_of_spades.gif';
import spades_9 from '../assets/images/cards/9_of_spades.gif';
import spades_10 from '../assets/images/cards/10_of_spades.gif';
import spades_jack from '../assets/images/cards/jack_of_spades.gif';
import spades_queen from '../assets/images/cards/queen_of_spades.gif';
import spades_king from '../assets/images/cards/king_of_spades.gif';
import spades_ace from '../assets/images/cards/ace_of_spades.gif';
import diamonds_2 from '../assets/images/cards/2_of_diamonds.gif';
import diamonds_3 from '../assets/images/cards/3_of_diamonds.gif';
import diamonds_4 from '../assets/images/cards/4_of_diamonds.gif';
import diamonds_5 from '../assets/images/cards/5_of_diamonds.gif';
import diamonds_6 from '../assets/images/cards/6_of_diamonds.gif';
import diamonds_7 from '../assets/images/cards/7_of_diamonds.gif';
import diamonds_8 from '../assets/images/cards/8_of_diamonds.gif';
import diamonds_9 from '../assets/images/cards/9_of_diamonds.gif';
import diamonds_10 from '../assets/images/cards/10_of_diamonds.gif';
import diamonds_jack from '../assets/images/cards/jack_of_diamonds.gif';
import diamonds_queen from '../assets/images/cards/queen_of_diamonds.gif';
import diamonds_king from '../assets/images/cards/king_of_diamonds.gif';
import diamonds_ace from '../assets/images/cards/ace_of_diamonds.gif';
import cardback from '../assets/images/cards/back_johnwick3.gif';

export const cardImages = {
    hearts_2,
    hearts_3,
    hearts_4,
    hearts_5,
    hearts_6,
    hearts_7,
    hearts_8,
    hearts_9,
    hearts_10,
    hearts_jack,
    hearts_queen,
    hearts_king,
    hearts_ace,
    clubs_2,
    clubs_3,
    clubs_4,
    clubs_5,
    clubs_6,
    clubs_7,
    clubs_8,
    clubs_9,
    clubs_10,
    clubs_jack,
    clubs_queen,
    clubs_king,
    clubs_ace,
    spades_2,
    spades_3,
    spades_4,
    spades_5,
    spades_6,
    spades_7,
    spades_8,
    spades_9,
    spades_10,
    spades_jack,
    spades_queen,
    spades_king,
    spades_ace,
    diamonds_2,
    diamonds_3,
    diamonds_4,
    diamonds_5,
    diamonds_6,
    diamonds_7,
    diamonds_8,
    diamonds_9,
    diamonds_10,
    diamonds_jack,
    diamonds_queen,
    diamonds_king,
    diamonds_ace,
    cardback,
}